export default __webpack_public_path__ + "static/media/london2.0a39743f.jpg";